import { useModalStore } from '@/shared/lib';
import { EditCardModal } from '../ui';
import type { SavedCard } from '@/entities/card';

type Params = {
  savedCard: SavedCard;
  onBack: () => void;
};

export function useEditCardModal() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const openEditCardModal = ({ savedCard, onBack }: Params) => {
    showDialogComponent({
      component: <EditCardModal savedCard={savedCard} onBack={onBack} />,
      className: 'sm:max-w-[48rem] max-h-[90vh] overflow-y-auto border-0 flex',
      onClose: closeDialog,
    });
  };

  return { openEditCardModal };
}
